import { render, staticRenderFns } from "./resources-data-collect.vue?vue&type=template&id=33b45d07&scoped=true&"
import script from "./resources-data-collect.vue?vue&type=script&lang=js&"
export * from "./resources-data-collect.vue?vue&type=script&lang=js&"
import style0 from "./resources-data-collect.vue?vue&type=style&index=0&id=33b45d07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b45d07",
  null
  
)

export default component.exports